import { useContext } from 'react';
import { assessmentsHooks } from '..';
import { AssessmentsContext, viewTypes } from '../AssessmentsContext';
import { checkTypes2 } from 'keys/checkTypes';
import { secretStorage } from 'config';
import { semesterAndYearOptions } from 'keys/years';
import { visibilityStatuseOptions, visibilityStatuses } from 'keys/visibilityStatuses';

const useCustomHeaderItems = () => {
    const { viewScreen } = useContext(AssessmentsContext)

    const is_superuser = secretStorage.getItem("user")?.is_superuser
    let headerItems = assessmentsHooks.useHeaderItems()

    let customHeaderItems = [
        {
            ...headerItems.year,
            options: semesterAndYearOptions,
            // זה היה סגור בלי סיבה מיוחדת , פתחתי כי אני לא יודעת למה חסמתי
            disabled: !is_superuser,
            name: "school_year",
        },
        {
            ...headerItems.semester,
            disabled: viewScreen == 'bar'
        },
        headerItems.grade_of_execution,
        {
            ...headerItems.category,
            multiple: false,
            focus: (viewScreen == viewTypes.profile) || (viewScreen == viewTypes.bar)
        },
        headerItems.assessment_def,
        headerItems.status,
        {
            name: "is_battery",
            component: "autoComplete",
            placeholder: "בודדים/סוללות",
            options: [{ id: "SINGLE", name: "מבודדים" }, { id: "BATTERY", name: "סוללות" }]
        },
        {
            name: "visibility_status",
            component: "autoComplete",
            placeholder: "סטטוס תצוגתי",
            options: visibilityStatuseOptions,
            hidden: !is_superuser,
        },
    ]

    const selectTestType = {
        component: "autoComplete",
        options: checkTypes2,
        name: "test_type",
        id: 6,
        placeholder: "תחום בדיקה",
        focus: true
    }

    return viewScreen === viewTypes.bar ?
        [...customHeaderItems, selectTestType] :
        customHeaderItems

}

export default useCustomHeaderItems